import { Box, InputBase, Typography, useTheme } from "@mui/material";
import type { ChangeEvent, Ref } from "react";

export type FlatRowTextareaProps = {
	label: string;
	value?: string;
	onChange?: (value: string) => void;
	onBlur?: () => void;
	inputRef?: Ref<HTMLTextAreaElement>;
	placeholder?: string;
	rows?: number;
	isLast?: boolean;
	error?: boolean;
	helperText?: string;
};

export const FlatRowTextarea = ({
	label,
	value,
	onChange,
	onBlur,
	inputRef,
	placeholder,
	rows = 3,
	isLast,
	error,
	helperText,
}: FlatRowTextareaProps) => {
	const theme = useTheme();

	const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
		onChange?.(event.target.value);
	};

	return (
		<Box
			sx={{
				borderBottom: isLast ? "none" : theme.colors.border.flatRowDivider,
			}}
		>
			<Box
				sx={{
					width: "100%",
					px: 2,
					py: 1.5,
				}}
			>
				<Typography
					variant="deprecatedBody1"
					color={
						error
							? theme.palette.deprecated.error.main
							: theme.palette.deprecated.grey[500]
					}
					mb={0.5}
				>
					{label}
				</Typography>
				<InputBase
					value={value ?? ""}
					onChange={handleChange}
					onBlur={onBlur}
					inputRef={inputRef}
					placeholder={placeholder}
					multiline
					minRows={rows}
					sx={{
						width: "100%",
						p: 0,
						"& textarea": {
							fontSize: 14,
							color: theme.palette.primary.main,
							resize: "none",
							"&::placeholder": {
								color: theme.palette.deprecated.grey[300],
								fontWeight: 400,
								opacity: 1,
							},
						},
					}}
				/>
			</Box>
			{error && helperText && (
				<Typography
					component="p"
					variant="deprecatedCaption"
					color={theme.palette.deprecated.error.main}
					px={2}
					pb={0.6}
				>
					{helperText}
				</Typography>
			)}
		</Box>
	);
};
